namespace app.support{
    export interface StfToggleButtonScope extends ng.IScope{
        config: StfToggleButtonConfig
        value: any
        autoFocus?: string
        fieldId: string
        required?: string
        disabled?: boolean
        onValueChange?: Function
    }

    export interface StfToggleButtonConfig{
        buttons: StfToggleButtonItem[],
        list?: any[]
        selectedListIndex?: any
    }

    export interface StfToggleButtonItem{
        id: string
        value?: any
        label: string
        icon?: StfToggleButtonIcon
        disabled?: boolean
        focusIf?: boolean
    }

    export interface StfToggleButtonIcon{
        svg?: string
        font?: string
    }

    /**
     * Diretiva stf-toggle-button
     * 
     */
    class StfToggleButton implements ng.IDirective{
        public restrict: string = 'E'
        public scope: Object = {
            'config': '=',
            'value': '=',
            'autoFocus': '@',
            'fieldId': '@',
            'required': '@',
            'disabled': '=?',
            'onValueChange': '&?'
        }

        public templateUrl:string = 'app/main/support/toggle/toggle-button.html'
        public controller: any = StfToggleButtonController
        public controllerAs: string = 'vm'

        /** @ngInject */
        constructor(private $timeout: ng.ITimeoutService){

        }

        public link($scope: StfToggleButtonScope, element: ng.IAugmentedJQuery, attrs: any,
            vm: StfToggleButtonController): void{
            let initializing = true;
            $scope.$watch('value', (value, oldValue) => {
                vm.value = value
                vm.disableButtonByValue()
                if (!initializing) { // Para não chamar o callback na primeira vez.
                    $scope.$applyAsync(() => {
                        if (vm.onValueChange) {
                            vm.onValueChange({ value })
                        }
                    })
                } else {
                    this.$timeout(() => initializing = false );
                }
            })

            $scope.$watchCollection('config', (newvalue, oldValue) => {
                $scope.$applyAsync(() => {
                    vm.updateListItems()
                })
            })

             $scope.$watch('disabled', value => {
                vm.disabled = <boolean> value
             })
        }

        public static factory(): ng.IDirectiveFactory{
            return ($timeout: ng.ITimeoutService) => {
                'ngInject'
                return new StfToggleButton($timeout)
            }
        }
    }

    angular
        .module('app.support')
        .directive('stfToggleButton', StfToggleButton.factory())
}
